import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      offset: 0,
      limit: 150,
      loadNextLogs: false,
    };
  },
  computed: {
    ...mapGetters({
      getterLogs: 'logs/result',
      getterIsLaunch: 'application/isLaunch',
    }),
    mixinsLogsGetErrorMessage() {
      return 'La date de début doit être inférieure ou égale à la date de fin';
    },
  },
  mounted() {
    this.resetField();
    this.storeResetChangeRoute();
    this.storeSetTimelineFixed(false);
  },
  methods: {
    ...mapActions({
      storeSearchLogs: 'logs/getMatchesLogs',
      storePushLogs: 'logs/pushLogsInResult',
      storeResetChangeRoute: 'application/resetChangeRoute',
      storeStartLoading: 'application/startLoading',
      storeStartSearch: 'application/startSearch',
      storeResetSearch: 'application/resetSearch',
      storeFinishLoading: 'application/finishLoading',
      storeSetTimelineFixed: 'application/setTimelineFixed',
    }),
    mixinsLogsLaunchSearch() {
      if (!this.isDisabledButtonSearch) {
        this.storeStartSearch();
        this.storeStartLoading();
        this.storeSearchLogs(this.parameters())
          .then(() => {
            this.storeFinishLoading();
          })
          .catch(() => this.storeFinishLoading());
      }
    },
    mixinsLogsGetNextResults() {
      if (this.getterIsLaunch && this.getterLogs.total_results > this.offset) {
        this.loadNextLogs = true;
        this.offset += this.limit;
        this.storePushLogs(this.parameters()).then(() => {
          this.loadNextLogs = false;
        }).catch(() => { this.loadNextLogs = false; });
      }
    },
    mixinsLogsInitDate(deltaMonth = 0) {
      const result = new Date();
      result.setDate(result.getDate() - Math.floor(deltaMonth * 30.417));
      return result.toISOString().substring(0, 10);
    },
    mixinsLogsClearResult() {
      this.storeResetSearch();
      this.offset = 0;
    },
  },
};
